/* Stores */
import useSnackBarStore from 'Stores/SnackBar';

/* Styles */
import './style.scss';

const SnackBar = () => {
	const snackBarData = useSnackBarStore(state => state.snackBar);

	return (
		<div className="snackbar-component">
			<div className={`snackbar-inner ${snackBarData.theme}`}>
				{snackBarData.status && (
					<span className="bodyBullet">{snackBarData.status} : </span>
				)}
				<span className="bodyBullet">{snackBarData.message}</span>
			</div>
		</div>
	);
};

export default SnackBar;
